import React from 'react';

const LoadingFallback = ({ message = 'Loading...' }) => {
  return (
    <div style={styles.container} role="status" aria-live="polite">
      <div style={styles.spinner}>
        <i className="pi pi-spin pi-spinner" style={styles.icon}></i>
      </div>
      <p style={styles.message}>{message}</p>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '300px',
    padding: '40px',
  },
  spinner: {
    marginBottom: '16px',
  },
  icon: {
    fontSize: '36px',
    color: '#6366f1',
  },
  message: {
    color: '#666',
    fontSize: '14px',
  },
};

export default LoadingFallback;
